/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetFoldersModel,
  IGetFoldersRequest,
  IMappers,
  IGetFoldersResponse,
  IGetFoldersResponseError,
  TGetFoldersResponse,
} from './types';

const defaultConfig: TGetFoldersModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'favorites',
  pathApi: '/v1/get-folders/',
  hostType: 'api',
} as TGetFoldersModel;

function createGetFoldersModel(parameters: IGetFoldersRequest): TGetFoldersModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetFoldersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetFoldersRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetFolders<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetFoldersOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetFoldersResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetFoldersModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetFoldersResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetFoldersResponseError);
    }
  }

  return { response, statusCode } as TGetFoldersResponse;
}

export { defaultConfig, createGetFoldersModel, fetchGetFolders };
